module.exports = new __parcel__URL__("brainstorm.953ba84e.gif").toString();